export const CREATE_STREAK = 'CREATE_STREAK';
export const FETCH_STREAKS = 'FETCH_STREAKS';
export const FETCH_STREAK = 'FETCH_STREAK';
export const EDIT_STREAK = 'EDIT_STREAK';
export const DELETE_STREAK = 'DELETE_STREAK';
export const FETCH_STREAK_FOCUS_SUMMARIES = 'FETCH_STREAK_FOCUS_SUMMARIES';
